import { render, staticRenderFns } from "./SchoolAwaySectionExportLegend.vue?vue&type=template&id=6e592e11&scoped=true&"
import script from "./SchoolAwaySectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./SchoolAwaySectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e592e11",
  null
  
)

export default component.exports